import request from '@/router/axios'

// 查询人员列表
export function queryEmpInfoListPage(data) {
  return request({
    url: '/sys/emp/queryEmpInfoListPage',
    method: 'post',
    data
  })
}
